var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.85,
    d: "m21.562 11.351-10.12-8.783a.43.43 0 0 0-.28-.104H8.79a.213.213 0 0 0-.14.375l9.38 8.143H2.358a.215.215 0 0 0-.214.214v1.607c0 .118.096.214.214.214h15.672L8.65 21.16a.213.213 0 0 0 .14.375h2.45c.05 0 .102-.018.14-.053l10.183-8.834a.858.858 0 0 0 0-1.297"
  })));
};
export default SvgRightArrow;